export const mapViewBy = {
  chart: {
    label: 'riskScaleAndInterpretation.chart',
    value: 0,
    isI18n: true,
  },
  table: {
    label: 'riskScaleAndInterpretation.table',
    value: 1,
    isI18n: true,
  },
}

export const SCORE_TABS = {
  byModelSegment: {
    label: 'distributionOfScore.byModelSegment',
    key: 'modelSegment',
  },
  byIndustry: {
    label: 'distributionOfScore.byIndustry',
    key: 'industry',
  },
  byCompanySize: {
    label: 'distributionOfScore.byCompanySize',
    key: 'companySize',
  },
}

export const COLOR_CHART_DISTRIBUTION = {
  ACTIVE: '#FFCD60',
  NOT_ACTIVE: '#006AA6',
}
